/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { Loader } from '@g17eco/atoms/loader';

export function WaitingComponent(Component: React.ComponentType<React.PropsWithChildren<unknown>>) {
  return (props: any) => (
    <React.Suspense fallback={<Loader />}>
      <Component {...props} />
    </React.Suspense>
  );
}
